import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css';

export function swiper() {

  const swiper = new Swiper(".swiper__about", {
    modules: [Autoplay, EffectFade],
    loop: true,
    speed: 2000,
    slidesPerView: 1.34,
    spaceBetween: 20,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
    },
    breakpoints: {
      767: {
        slidesPerView: 1.97,
        spaceBetween: 60,
        centeredSlides: true,
      }
    }
  });

  const swiper2 = new Swiper(".swiper__media", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    speed: 2000,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    // autoplay: {
    //   delay: 2000,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        initialSlide: 1,
        slidesPerView: 3,
        spaceBetween: 34,
        centeredSlides: true,
      }
    }
  });

  const swiper4 = new Swiper(".swiper__topic", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    speed: 2000,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,

    // autoplay: {
    //   delay: 2000,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        initialSlide: 1,
        slidesPerView: 3,
        spaceBetween: 34,
        centeredSlides: true,
      }
    }
  });

  const swiper3 = new Swiper(".swiper__pickup", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    loop: true,
    speed: 1000,
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 8,
        spaceBetween: 20,
        // centeredSlides: true,
      }
    }
  });
}